import { useState, useEffect } from 'react'
import Box from '@mui/joy/Box'
import Sheet from '@mui/joy/Sheet'
import Tab, { tabClasses } from '@mui/joy/Tab'
import Tabs from '@mui/joy/Tabs'
import TabList from '@mui/joy/TabList'
import TabPanel from '@mui/joy/TabPanel'
import { fabric } from 'fabric'
import { ButtonPanel } from './ButtonPanel'
import { TemplateAPI } from '../api/TemplateAPI'
import { TemplateTextbox } from '../objects/TemplateTextbox'
import { TemplatePreview } from './TemplatePreview'
import { canvasActions } from '../common/canvasActions'
import { useQuery } from '@tanstack/react-query'

export const EditorPanel = ({ canvas, onTemplateChange }) => {
    const { isPending, data } = useQuery({
        queryKey: ['libraryTemplates'],
        queryFn: TemplateAPI.getTextTemplates,
    })
    const [selectedId, setSelectedId] = useState(null)
    const templates = data ? data.data : []

    useEffect(() => {
        if (templates.length > 0) {
            let id = templates[0].id
            setSelectedId(id)
            onTemplateChange(id)
        }
    }, [templates])

    const handleFile = (e) => {
        var file = e.target.files[0]
        var reader = new FileReader()
        reader.addEventListener(
            'load',
            () => {
                // convert image file to base64 string
                fabric.Image.fromURL(reader.result, function (oImg) {
                    var scale = 200 / oImg.width
                    oImg.set({ scaleX: scale, scaleY: scale })
                    canvas.add(oImg)
                    canvas.renderAll()
                })
            },
            false
        )
        reader.readAsDataURL(file)
    }

    const handleTemplateSelected = (id) => {
        setSelectedId(id)
        onTemplateChange(id)
    }

    const templateButtons = templates.map((template, index) => (
        <Box key={index} sx={{ mb: 2 }}>
            <TemplatePreview
                img={template.preview_image}
                isSelected={selectedId === template.id}
                onClick={() => handleTemplateSelected(template.id)}
            >
                Template {index}
            </TemplatePreview>
        </Box>
    ))

    return (
        <Sheet
            sx={{
                borderWidth: '0 1px 0 0',
                height: '100%',
                overflow: 'auto',
                px: 2,
            }}
            variant="outlined"
            color="neutral"
        >
            <Tabs aria-label="Basic tabs" defaultValue={0}>
                <TabList
                    disableUnderline
                    tabFlex={1}
                    sticky="top"
                    sx={{
                        p: 0.5,
                        gap: 0.5,
                        borderRadius: 'xl',
                        bgcolor: 'background.level1',
                        [`& .${tabClasses.root}[aria-selected="true"]`]: {
                            boxShadow: 'sm',
                            bgcolor: 'background.surface',
                        },
                    }}
                >
                    <Tab disableIndicator>Library</Tab>
                    <Tab disableIndicator>Shapes</Tab>
                </TabList>
                <TabPanel value={0}>
                    {isPending ? <div>Loading</div> : <>{templateButtons}</>}
                </TabPanel>
                <TabPanel value={1}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                        }}
                    >
                        <ButtonPanel
                            onRectClick={() =>
                                canvasActions.addRectangle(canvas)
                            }
                            onCircleClick={() =>
                                canvasActions.addCircle(canvas)
                            }
                            onTriangleClick={() =>
                                canvasActions.addTriangle(canvas)
                            }
                            onTextboxClick={() =>
                                canvasActions.addTextbox(canvas)
                            }
                            onFileChange={handleFile}
                        />
                    </Box>
                </TabPanel>
            </Tabs>
        </Sheet>
    )
}
